import pickDay from '../components/pick-day/pick-day-redux'

export default pickDay
